module.exports = __webpack_public_path__ + "static/media/04s.c10f25aa.png";